export const API_BASE_URL = process.env.NEXT_PUBLIC_BACKEND_URL || '';

// 🔐 Auth & User
export const API_SEND_RESET_OTP = '/api/v2/send-reset-otp';
export const API_VERIFY_RESET_OTP = '/api/v2/verify-reset-otp';
export const API_PASSWORD_CONFIRM_RESET = '/api/v2/auth/password/confirm_reset';
export const API_SEND_LOGIN_OTP = '/api/v2/send-login-otp';
export const API_VERIFY_LOGIN_OTP = '/api/v2/verify-login-otp';
export const API_SIGNUP = '/api/v2/auth/signup';
export const API_LOGIN = '/api/v2/auth/web/login';
export const API_LOGOUT = '/api/v2/auth/web/logout';
export const API_USER = '/api/user';

// 🏠 General & Settings
export const API_GENERAL_SETTINGS = '/api/v2/general-settings';
export const API_BUSINESS_SETTINGS = '/api/v2/business-settings';

// 🛍️ Product & Brand
export const API_BRANDS = '/api/v2/brands';
export const API_VERIFY_PRODUCTS = '/api/v2/verify-products/check';
export const API_PRODUCTS_BASE = '/api/v2/products';
export const API_PRODUCT_AUTHENTIC_REVIEWS_SUBMIT =
  '/api/v2/product-authentic-reviews/submit';
export const API_PRODUCT_AUTHENTIC_REVIEWS_UPDATE = (
  productId: string | number
) => `/api/v2/product-authentic-reviews/update/${productId}`;
export const API_RELATED_PRODUCTS = (productSlug: string) =>
  `/api/v2/gigalogy/related-products/${productSlug}`;
export const API_PRODUCT_DETAILS = (slug: string) =>
  `/api/v2/products/${slug}?nuxt=true`;

// 📰 Blogs
export const API_BLOGS = '/api/v2/blogs';
export const API_BLOG_CATEGORIES = '/api/v2/blog/categories';
export const API_BLOG_TRENDING_TAGS = '/api/v2/blog/trending/tags';
export const API_BLOG_SINGLE = (slug: string) => `/api/v2/blog/${slug}`;
export const API_BLOG_COMMENT_STORE = '/api/v2/blog/comment/store';

// 📬 Contact
export const API_CONTACT_US = '/api/v2/contact-us';

// 🧑‍🤝‍🧑 Community
export const API_COMMUNITY_POSTS = '/api/v2/community-posts';
export const API_COMMUNITY_TRENDING_TAGS =
  '/api/v2/community-posts/trending/tags';
export const API_COMMUNITY_POST_DETAILS = (id: string | number) =>
  `/api/v2/community-posts/${id}`;
export const API_COMMUNITY_POST_CREATE = `/api/v2/community-post-create`;
export const API_COMMUNITY_COMMENT_CREATE = '/api/v2/community-comment-create';
export const API_COMMUNITY_LIKE_UPDATE = '/api/v2/community-like-update';

// 🛒 Cart & Checkout
export const API_CARTS = '/api/v2/carts';
export const API_CART_ADD = '/api/v2/web/carts/add';
export const API_CART_CHANGE_QUANTITY = '/api/v2/carts/change-quantity';
export const API_CART_DELETE = (id: string | number) => `/api/v2/carts/${id}`;
export const API_CART_SUMMARY = (cityId: string | number) =>
  `/api/v2/web/cart-summary?city_id=${cityId}`;
export const API_COUPON_APPLY = '/api/v2/coupon-apply/on-cart';
export const API_COUPON_REMOVE = '/api/v2/coupon-remove';
export const API_CREDENTIAL_ORDER_STORE = '/api/v2/credential/order-store/v2';

// 🛍️ Order & Shipping
export const API_ORDER_DETAILS = (orderId: string | null | number) =>
  `/api/v2/order-details/${orderId}`;
export const API_ORDER_SHIPPING_UPDATE = (orderId: string | number) =>
  `/api/v2/order/shipping-update/${orderId}`;
export const API_AUTHENTIC_USER_ORDER_HISTORY =
  '/api/v2/authentic-user-order-history';

// 🧾 Profile
export const API_PROFILE_UPDATE = '/api/v2/profile/update';
export const API_PROFILE_AVATAR_UPDATE = '/api/v2/profile/update-avatar';

// 🏷️ Wishlist
export const API_WISHLISTS = '/api/v2/wishlists';
export const API_WISHLISTS_ADD_PRODUCT = (productId: string | number) =>
  `/api/v2/wishlists-add-product?product_id=${productId}`;
export const API_WISHLISTS_REMOVE_PRODUCT = (productId: string | number) =>
  `/api/v2/wishlists-remove-product?product_id=${productId}`;
export const API_WISHLISTS_CHECK_PRODUCT = (productId: string | number) =>
  `/api/v2/wishlists-check-product?product_id=${productId}`;

// 🏡 Home
export const API_HOME_THINGS = '/api/v2/home-things?for=desktop';
export const API_HOME_FEATURED_CATEGORIES = '/api/v2/home-featured-categories';
export const API_SIDEBAR_DATA = '/api/v2/sidebar-data?new=true';

// 🏢 Address & Location
export const API_USER_SHIPPING_ADDRESS = '/api/v2/user/shipping/address';
export const API_CITIES_BY_COUNTRY = (countryId: string | number) =>
  `/api/v2/cities-by-country/${countryId}`;
export const API_ZONES_BY_CITY = (cityId: string | number) =>
  `/api/v2/zones-by-city/${cityId}`;
export const API_AREAS_BY_ZONE = (zoneId: string | number) =>
  `/api/v2/areas-by-zone/${zoneId}`;

// 🎥 KireiTube & Videos
export const API_KIREITUBE_HOME = '/api/v2/kireitube-home';
export const API_YOUTUBE_VIDEOS = (slug: string) =>
  `/api/v2/youtube-videos/${slug}`;
export const API_YOUTUBE_VIDEOS_ORIENTATION = (
  orientation: string,
  queryString: string
) => `/api/v2/youtube-videos?orientation=${orientation}&${queryString}`;
export const API_KIREITUBE_PLAYLIST = (slug: string) =>
  `/api/v2/kireitube-playlist/${slug}`;

// 🧾 FAQ & Testimonials
export const API_FAQS = '/api/v2/faqs';
export const API_TESTIMONIALS = '/api/v2/testimonials';

// 🏆 Membership & Rewards
export const API_USER_MEMBERSHIPS = '/api/v2/user-memberships';
export const API_USER_REWARDS = '/api/v2/user-rewards';
export const API_USER_REWARD_BALANCE = '/api/v2/user-reward-balance';

// 🛒 Gigalogy & Search
export const API_GIGALOGY_SEARCH = '/api/v2/gigalogy/items/search';
export const API_GIGALOGY_SEARCH_QUERY = (query: string) =>
  `/api/v2/gigalogy/items/search?search=${query}`;
export const API_PRODUCTS_TODAYS_HOT_DEAL = '/api/v2/products-todays-hot-deals';
export const API_GIGALOGY_USERS_RECOMMEND = '/api/v2/gigalogy/users/recommend';
export const API_GIGALOGY_USERS_SEARCH_RECOMMEND =
  '/api/v2/gigalogy/users/search/recommend';

// 🎁 Others
export const API_SURPRIZE_STORE = '/api/v2/surprize-store';
export const API_GROUPS = '/api/v2/groups';
export const API_GROUPS_DETAILS = (id: string | number) =>
  `/api/v2/groups/details/${id}`;
export const API_GROUPS_STORE = '/api/v2/groups/store';
export const API_GROUPS_JOIN = (id: string | number) =>
  `/api/v2/groups/join/${id}`;
export const API_INFLUENCER_DETAILS = (slug: string) =>
  `/api/v2/influencers/${slug}`;
export const API_PURCHASE_HISTORY = '/api/v2/purchase-history';
export const API_PRODUCT_QUESTION = '/api/v2/product-question';
export const API_REVIEWS_SUBMIT = '/api/v2/reviews/submit';
